//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NEU',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
      },
      active: 0,
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    numChange() {
      this.active = !this.active
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      if (self.form.item1 == '') {
        self.form.item1 = '0'
      }
      if (self.form.item2 == '') {
        self.form.item2 = '0'
      }
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        if (self.active == 0) {
          if (form.item1 == 0) {
            self.hasScore = false
            return
          }
          if (form.item1 >= 1.5) {
            result = 1
            self.text = '轻度中性粒细胞减少'
          } else if (form.item1 >= 1 && form.item1 < 1.5) {
            result = 2
            self.text = '轻度中性粒细胞减少症'
          } else if (form.item1 >= 0.5 && form.item1 < 1) {
            result = 3
            self.text = '中度中性粒细胞减少症，感染风险增加，建议及时调整药物剂量或停药'
          } else if (form.item1 < 0.5) {
            result = 4
            self.text = '重度中性粒细胞减少症(粒细胞缺乏症)，感染风险明显增加，可能危及生命，需紧急干预'
          }
        } else {
          if (form.item2 == 0) {
            self.hasScore = false
            return
          }
          if (form.item2 >= 1500) {
            result = 1
            self.text = '轻度中性粒细胞减少'
          } else if (form.item2 >= 1000 && form.item2 < 1500) {
            result = 2
            self.text = '轻度中性粒细胞减少症'
          } else if (form.item2 >= 500 && form.item2 < 1000) {
            result = 3
            self.text = '中度中性粒细胞减少症，感染风险增加，建议及时调整药物剂量或停药'
          } else if (form.item2 < 500) {
            result = 4
            self.text = '重度中性粒细胞减少症(粒细胞缺乏症)，感染风险明显增加，可能危及生命，需紧急干预'
          }
        }
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/NEU.vue